import get from 'lodash/get';

import env from 'Env';

export default function postToStructuredData(post) {
  const title = get(post, 'data.title[0].text', '');
  const author = get(post, 'data.author', 'Sam Jones');
  const created = get(post, 'first_publication_date', get(post, 'data.publication_datetime', ''));
  const modified = get(post, 'last_publication_date', get(post, 'data.publication_datetime', ''));

  const image = get(post, 'data.cover.url', get(post, 'data.cover.752x423.url', get(post, 'data.cover.400x225.url', get(post, 'data.cover.224x126.url'))));

  if (!title || !created) {
    return undefined;
  }

  const url = `${env.appProtocol}://${env.appUrl}/${window.locale || 'en'}/blog/${post.uid}`;

  return {
    '@id': `${url}#article`,
    '@type': 'Article',
    author: {
      '@type': 'Person',
      name: author,
    },
    datePublished: created,
    dateModified: modified,
    headline: title,
    publisher: {
      '@id': 'https://www.fanatical.com/en/#organization',
    },
    image,
    url,
    mainEntityOfPage: {
      '@id': `${url}#webpage`,
      '@type': 'ItemPage',
    },
  };
}
